import React, { FunctionComponent, PropsWithChildren } from 'react';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { FeatureFlagClient } from './feature-flag.config';
import { useFeatureFlagInit } from './feature-flag.hooks';
import { FeatureFlagInitOptions } from './feature-flag.types';

interface FeatureFlagProviderProps extends PropsWithChildren {
  settings: {
    featureFlag: FeatureFlagClient;
    initOptions?: FeatureFlagInitOptions;
  };
}

export const FeatureFlagProvider: FunctionComponent<
  FeatureFlagProviderProps
> = ({ settings: { featureFlag, initOptions }, children }) => {
  /**
   * Important: The feature flag SDK must be initialized before using it.
   */
  useFeatureFlagInit({ featureFlag, initOptions });

  return (
    <GrowthBookProvider growthbook={featureFlag}>{children}</GrowthBookProvider>
  );
};
